module.exports = __webpack_public_path__ + "img/logo.4c1d80f9.png";